<style scoped>
.mega-dropdown {
  position: static !important;
}

.mega-dropdown-menu {
  padding: 20px 0px;
  width: 50%;
  box-shadow: none;
  -webkit-box-shadow: none;
  /* max-width: 1300px; */
  margin: 0 auto;
}

.mega-dropdown-menu > li > ul {
  padding: 0;
  margin: 0;
}

.mega-dropdown-menu > li > ul > li {
  list-style: none;
}

.mega-dropdown-menu > li > ul > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.428571429;
  color: #999;
  white-space: normal;
}

.mega-dropdown-menu > li ul > li > a:hover,
.mega-dropdown-menu > li ul > li > a:focus {
  text-decoration: none;
  color: #444;
  background-color: #f5f5f567;
}

.mega-dropdown-menu .dropdown-header {
  color: #428bca;
  font-size: 18px;
  font-weight: bold;
}

.mega-dropdown-menu form {
  margin: 3px 20px;
}

.mega-dropdown-menu .form-group {
  margin-bottom: 3px;
}
</style>
<template>
  <div>
    <b-navbar toggleable="lg" type="light" class="fixed-top navbar-primary">
      <b-container fluid>
        <b-navbar-brand to="/"
          ><b-img
            src="/img/logo-text.svg"
            fluid
            alt="Responsive image"
            class="indah-brand"
          ></b-img
        ></b-navbar-brand>
        <b-navbar-brand to="/pmse"
          ><b-img
            src="/img/application/pmse.png"
            fluid
            alt="Responsive image"
            class="indah-brand"
            style="margin-left: -1.25rem; background: #fff"
          ></b-img
        ></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" class="mr-2 text-white">
          <template #default="{ expanded }">
            <b-icon v-if="expanded" icon="x"></b-icon>
            <b-icon v-else icon="list"></b-icon>
          </template>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          
          <b-navbar-nav
            v-if="this.$store.getters['auth/isAuthenticated']"
            class="ml-auto"
          >
            <b-nav-item v-if="$route.name == 'PMSEPerekamanData'">
              <b-container>
                <b-row align-v="center" align-h="end">
                  <b-col lg="2" class="mr-0"> Periode: </b-col>
                  <b-col lg="9" class="ml-3">
                    <b-form-select
                      size="sm"
                      v-model="periode"
                      :options="periodeOpts"
                      v-on:change="onChangePeriode"
                    >
                      <template #first>
                        <b-form-select-option :value="{}" disabled
                          >-- Pilih Periode --</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-container>
            </b-nav-item>
            <b-dropdown
              right
              size="sm"
              variant="logout"
              :text="$store.getters['auth/user'].name"
            >
              <b-dropdown-item
                to="/pmse/ubah-profil"
                v-if="user.role.includes('ROLE_PPMSE')"
                >Profil</b-dropdown-item
              >
              <b-dropdown-item
                to="/pmse/ubah-profil-kl"
                v-if="user.role.includes('ROLE_PMSE_PEMERINTAH')"
                >Profil</b-dropdown-item
              >
              <b-dropdown-item
                to="/pmse/ubah-profil-bps"
                v-if="user.email.split('@')[1] == 'bps.go.id'"
                >Profil Pengguna Internal</b-dropdown-item
              >
              <b-dropdown-item
                to="/pmse/pengaturan/user/change-password"
                v-if="user.email.split('@')[1] != 'bps.go.id'"
                >Ganti Password</b-dropdown-item
              >
              <!-- <b-dropdown-item to="/profile/change-password"
                >Ubah Password</b-dropdown-item
              > -->
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item to="/logout-pmse">Keluar</b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
import PmseService from "../../services/PmseService";
import { isRoleOperator } from "../../utils/commonUtils";
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  data() {
    return {
      openMegaMenu: false,
      periodeOpts: [],
      periodeSelected: null,
      // approved: false,
      // admin: false,
    };
  },
  components: {},
  methods: {
    isOperatorPMSE(roles) {
      console.log(roles)
      if(roles.length > 0) 
        return isRoleOperator(roles);
    },
    isPusat() {
      return (
        this.user.kdorganisasi != undefined &&
        this.user.kdorganisasi.substring(0, 2) == "00"
      );
    },
    isBps() {
      return !(
        this.user.kdorganisasi == undefined && this.user.kdorganisasi == null
      );
    },
    onChangePeriode(value) {
      this.$store.dispatch("pmse/setPeriode", value);
    },

    async loadPeriodeActive() {
      await PmseService.getPeriodesActiveByPerusahaan().then(
        (response) => {
          this.periodeOpts = response.data.data.map((x) => {
            return {
              text: "Tahun " + x.tahun + " - Triwulan " + x.triwulan,
              value: x,
            };
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
    show() {
      if (this.$store.getters["mega_menu/isShow"]) {
        this.$store.dispatch("mega_menu/hide");
      } else {
        this.$store.dispatch("mega_menu/show");
      }
    },
    closeEvent: function () {
      this.$store.dispatch("mega_menu/hide");
    },
  },
  mounted() {
    if (this.$store.getters["auth/isAuthenticated"]) {
      this.loadPeriodeActive();
    }
  },
  computed: {
    ...mapGetters({
      periodeFromStore: "pmse/getPeriode",
      user: "auth/user",
      dataPerusahaanFromStore: "pmse/getDataPerusahaan",
    }),
    periode: {
      get() {
        return this.periodeFromStore;
      },
      set(periode) {
        this.$store.dispatch("pmse/setPeriode", periode);
      },
    },
    dataPerusahaan: {
      get() {
        return this.dataPerusahaanFromStore;
      },
      set(dp) {
        this.$store.dispatch("pmse/setDataPerusahaan", dp);
      },
    },
  },
};
</script>
